/**
 * Bridges the nav dropdown's related-questions list (rendered by the legacy,
 * non-bundled media/js/app.js) to the same per-session "seen questions" tracking
 * used on the semantic search page (see storage/seenQuestionsTracker.js), so a
 * question shown once in either place isn't shown again in the other - both pull
 * from the same site-wide related-questions pool (get_related_questions_for_site).
 *
 * app.js can't `import` this directly since it isn't part of this bundle's module
 * graph, so the filter is exposed on `window` instead.
 */
import { markAsSeen, selectUnseenQuestions } from '../storage/seenQuestionsTracker';

const NAV_QUESTION_COUNT = 5;

window.filterUnseenNavRelatedQuestions = (allQuestions) => {
  const unseenQuestions = selectUnseenQuestions(allQuestions || [], NAV_QUESTION_COUNT);
  unseenQuestions.forEach((q) => markAsSeen(q.question));
  return unseenQuestions;
};
